import { createFileRoute } from '@tanstack/react-router'
import { CustomerCollectionPolicy } from '@/features/bot/index.ts'

export const Route = createFileRoute('/_authenticated/customer-management/customers/$customerId/collection-policy')({
  component: Page
})
function Page() {
  return <CustomerCollectionPolicy customerId={Number(Route.useParams().customerId)} />
}
